import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import { faPrint } from "@fortawesome/free-solid-svg-icons"; 
import '../utils/Pagos.css';
import logo from '../components/public/llave.jpg';
import moment from 'moment-timezone';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const API_URL_PAGOS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/pagos` 
  : 'http://localhost:4000/pagos';

  const API_URL_USUARIOS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/usuarios` 
  : 'http://localhost:4000/usuarios';


const Pagos = () => {
  const [pagos, setPagos] = useState([]);
  const [filteredPagos, setFilteredPagos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPago, setSelectedPago] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedRows, setSelectedRows] = useState({}); // Usamos un objeto para cada fila
  const totalPagar = Object.values(selectedRows).reduce((total, pago) => total + parseFloat(pago.total_pagar || 0), 0).toFixed(2);
  const [showModalImpresora, setShowModalImpresora] = useState(false);
  const [selectedPagoId, setSelectedPagoId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false); // Nuevo estado para controlar el clic
  const [verPendientes, setVerPendientes] = useState(false);

  const [newPago, setNewPago] = useState({
    numero_comprobante: '',
    id_consumo: '',
    id_medidor: '',
    id_usuario: '',
    nombre_tesorera: '',
    nombre_cliente: '',
    lectura_anterior: '',
    lectura_actual: '',
    consumo: '',
    exceso: '',
    mora: '',
    reconexion: '',
    mes: '',
    fecha_pago: '',
    total_pagar: '',
    estado: 'pendiente',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchPagos();
  }, []);

  useEffect(() => {
    console.log(selectedPago); // Esto se ejecutará cada vez que selectedPago cambie
  }, [selectedPago]);

  const fetchPagos = async () => {
    try {
      
      const response = await axios.get(API_URL_PAGOS);
      const sortedPagos = response.data.sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago));
      setPagos(sortedPagos);
      setFilteredPagos(sortedPagos); // Actualiza los pagos filtrados
    } catch (error) {
      console.error('Error fetching pagos data:', error);
    }
  };
// pruebas
  /*const handleSeleccionarPagos = (rows) => {
    console.log("Pagos seleccionados:", rows); // 🔍 VER QUÉ CAMPOS ESTÁN LLEGANDO
    setSelectedRows(rows);
  };
  useEffect(() => {
    console.log("selectedRows cargados en el modal:", selectedRows);
  }, [selectedRows]);
*/
  
// Función para obtener el pago y asignarlo a selectedPago
const fetchPagoById = async (id) => {
  try {
    const response = await axios.get(process.env.REACT_APP_API_URL + `/pagos/${id}`); // Usa la variable de entorno
    //const response = await axios.get(`http://localhost:4000/pagos/${id}`);
    setSelectedPago(response.data);  // Asignar la respuesta completa

    // Verificar en el siguiente paso si `numero_comprobante` está en selectedPago
    if (response.data.numero_comprobante) {
    }
  } catch (error) {
    console.error("Error al obtener el pago:", error);
  }
};

useEffect(() => {
  if (selectedPago) {
  }
}, [selectedPago]);
  

const filterPagos = async (term) => {
  const termStr = term.toString().trim().toLowerCase();

  try {
    if (!term) {
      // No hay término de búsqueda, usar los datos actuales
      if (verPendientes) {
        const response = await axios.get(`${API_URL_PAGOS}/pendientes`);
        setFilteredPagos(response.data);
      } else {
        const response = await axios.get(`${API_URL}/pagos`);
        setFilteredPagos(response.data);
      }
    } else {
      // Si hay término de búsqueda
      const response = await axios.get(`${API_URL}/pagos/filtrar/${termStr}`);
      const pagosFiltrados = response.data;

      // Si estamos en modo pendientes, filtramos adicionalmente por estado !== "PAGADO"
      const resultado = verPendientes
        ? pagosFiltrados.filter(p => p.estado !== 'PAGADO')
        : pagosFiltrados;

      setFilteredPagos(resultado);
    }
  } catch (error) {
    console.error("Error al filtrar los pagos", error);
  }
};


const formatFecha = (fecha) => {
    if (!fecha) return ''; // Si la fecha no está disponible
  
    // Convertir la fecha en formato ISO a un objeto Date
    const date = new Date(fecha);
  
    // Formatear la fecha a la zona horaria local (asegurándote de que no se aplique desfase)
    return date.toLocaleDateString('es-ES', {
      weekday: 'short', // Día de la semana (opcional)
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
  };
  

// Función para manejar la selección de la flecha

  const handleOpenModal = () => {
    setNewPago({
      numero_comprobante: '',
      id_consumo: '',
      id_medidor: '',
      id_usuario: '',
      lectura_anterior: '',
      lectura_actual: '',
      consumo: '',
      exceso: '',
      mora: '',
      reconexion: '',
      mes: '',
      fecha_pago: '',
      total_pagar: '',
      estado: 'pendiente',
      nombre_tesorera: '',
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPago(null);
    setErrorMessage('');
      // Restablecer la selección de las filas en la tabla (deseleccionar)
  setSelectedRows({});  // Esto deselecciona todas las filas
  };
  
  const handlePagar = () => {
    if (Object.keys(selectedRows).length === 0) {
      alert("Por favor selecciona al menos un registro para pagar.");
      return;
    }
    setShowModal(true);
  };
  

  const toggleSelection = (index) => {
    setSelectedRows((prevSelectedRows) => {
      const newSelectedRows = { ...prevSelectedRows };
      const selectedPago = filteredPagos[index];
  
      // Usar el id_usuario del localStorage si no está presente en selectedPago
      const idUsuario = localStorage.getItem('id_usuario');
      if (!selectedPago.id_usuario && idUsuario) {
        selectedPago.id_usuario = idUsuario; // Asignar el id_usuario desde localStorage
      }
  
      if (newSelectedRows[index]) {
        delete newSelectedRows[index]; // Deseleccionar
      } else {
        newSelectedRows[index] = selectedPago; // Seleccionar
      }
  
      return newSelectedRows;
    });
  };


  const handleAddPago = async () => {
    //console.log("Enviando los siguientes pagos al backend:");
    //console.log(Object.values(selectedRows));
    if (isProcessing) return; // Si ya estamos procesando, no hacer nada
    setIsProcessing(true); // Deshabilitar el botón al hacer clic
    
    try {
      // Obtener el id_usuario desde localStorage
      const idUsuario = localStorage.getItem('id_usuario');
      if (!idUsuario) {
        alert("No se encontró información del usuario.");
        return;
      }
      // Crear los pagos a enviar al backend
      const pagosAEnviar = Object.values(selectedRows).map((pago) => {
  
        // Verificar si el id_usuario está presente y tiene un valor válido
        if (!pago.id_usuario) {
          pago.id_usuario = idUsuario; // Asignar el id_usuario del localStorage si está vacío
        }
        // Si necesitas el nombre del tesorero, puedes usarlo directamente desde localStorage
        const nombreTesorera = localStorage.getItem('nombre_usuario') || "Tesorera No Encontrada";
         // Ajustar la fecha con la zona horaria de Guayaquil usando moment-timezone
        const fechaHoy = moment.tz('America/Guayaquil').format('YYYY-MM-DD');
  
        return {
          id_consumo: pago.id_consumo,
          id_medidor: pago.id_medidor,
          fecha_pago: fechaHoy, // Fecha actual
          nombre_cliente: pago.nombre_cliente,
          nombre_tesorera: nombreTesorera, // Usar el nombre del tesorero desde localStorage
          estado_pago: "Pagado",
          lectura_anterior: pago.lectura_anterior,
          lectura_actual: pago.lectura_actual,
          exceso: pago.exceso, // Uso directo sin validación
          consumo_total: pago.consumo,
          valor_exceso: "0.00",
          mora: pago.mora,  
          total_pagar: pago.total_pagar,
          firma_tesorera: "i",
          numero_comprobante: Math.floor(Math.random() * 100000).toString(),
          id_usuario: pago.id_usuario, // Asegurarse de que se toma el id_usuario
        };
      }).filter(pago => pago !== null); // Filtrar los pagos nulos (sin id_usuario)
  
        // Aquí imprime lo que se enviará al backend justo antes de enviar
        //console.log("Pagos a enviar al backend:", pagosAEnviar);

      // Validación de los pagos antes de enviarlos
      const validarPago = (pago) => {
        const camposObligatorios = [
          "id_consumo",
          "id_medidor",
          "id_usuario",
          "fecha_pago",
          "nombre_cliente",
          "nombre_tesorera",
          "estado_pago",
          "lectura_anterior",
          "lectura_actual",
          "consumo_total",
          "valor_exceso",
          "total_pagar",
          "firma_tesorera",
          "numero_comprobante",
        ];
  
        // Verificar que todos los campos obligatorios tengan valores válidos
        for (const campo of camposObligatorios) {
          if (pago[campo] === undefined || pago[campo] === null || pago[campo] === "") {
            console.error(`El campo ${campo} está vacío o es inválido:`, pago);
            return false;
          }
        }
        return true;
      };
  
      // Filtrar pagos válidos
      const pagosValidos = pagosAEnviar.filter(validarPago);
  
      if (pagosValidos.length !== pagosAEnviar.length) {
        alert("Algunos pagos tienen datos incompletos o inválidos.");
        return; // Detener el proceso si hay datos inválidos
      }
  
      // Enviar los pagos al backend usando axios
      await Promise.all(
        pagosAEnviar.map((pago) => axios.post(API_URL_PAGOS, pago))
      );
  
      // Si la operación fue exitosa, mostrar mensaje y actualizar datos
      alert("Pagos registrados exitosamente.");
      fetchPagos(); // Obtener los pagos actualizados
      handleCloseModal(); // Cerrar el modal si es necesario
    } catch (error) {
      // Manejo de errores, mostrando detalles del error
      if (error.response) {
        console.error("Error del backend:", error.response.data);
        console.error("Estado del error:", error.response.status);
        console.error("Cabeceras del error:", error.response.headers);
      } else {
        console.error("Error inesperado:", error.message);
      }
      alert("Hubo un error al registrar los pagos. Ver consola para más detalles.");
    } finally {
      setIsProcessing(false); // Habilitar el botón nuevamente al finalizar
    }
  };
  
   

  const handleEditPago = (pago) => {
    setSelectedPago(pago);
    setNewPago({ ...pago });
    setShowModal(true);
  };

  const handleUpdatePago = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_URL_PAGOS}/${selectedPago.id_pago}`, newPago);
      fetchPagos();
      filterPagos(searchTerm);
      handleCloseModal();
    } catch (error) {
      console.error('Error updating pago:', error);
      setErrorMessage('Error al actualizar el pago.');
    }
  };

  const handleDelete = (pago) => {
    setSelectedPago(pago);
    setShowDeleteConfirm(true);
  };

  const handleImpresoraClick = (pago) => {
    setSelectedPago(pago); // Guardamos el pago seleccionado
    setShowModalImpresora(true); // Abrimos el modal
  };
  
  
const handleCloseModalImpresora = () => {
  setShowModalImpresora(false);
  setSelectedPago(null); // Limpiamos el pago seleccionado
};


const generarComprobante = (selectedPago) => {
  // Obtén el contenido del modal
  const modalContent = document.querySelector('.custom-modal .modal-content');

  if (!modalContent) {
    alert("No hay contenido para imprimir.");
    return;
  }

  // Excluimos los botones de Cancelar e Imprimir de la impresión
  const botones = modalContent.querySelectorAll('button');
  botones.forEach(button => button.style.display = 'none'); // Ocultar los botones

  // Crear una ventana para la impresión
  const ventanaImpresion = window.open('', '', 'width=800,height=600');

  // Crear el contenido de la página de impresión
  ventanaImpresion.document.write('<html><head><title>Comprobante de Pago</title>');

  // Agregar los estilos directamente para que las líneas y otros elementos se vean bien
  ventanaImpresion.document.write(`
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 20px;
      }

      .intro-image img {
        max-width: 30%; /* Ajustamos el tamaño de la imagen */
        height: auto;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      }

      .comprobante {
        text-align: center;
        margin: 20px;
      }

      .comprobante p {
        font-size: 16px;
      }

      h2 {
        font-size: 24px;
        margin-top: 20px;
      }

      /* Estilos para las líneas */
      .line {
        border-top: 1px solid #000; /* Línea después del campo CAJERO */
        margin: 10px 0;
      }

      .footer-line {
        border-bottom: 1px solid #000; /* Línea al final del comprobante */
        margin: 20px 0;
      }
    </style>
  `);

  ventanaImpresion.document.write('</head><body>');

  // Copiar el contenido del modal
  ventanaImpresion.document.write(modalContent.innerHTML);

// Buscar el campo "Código de Medidor" y agregar la línea antes de él
const paragraphs = ventanaImpresion.document.querySelectorAll('p');
paragraphs.forEach((p) => {
  if (p.textContent.includes("Código de Medidor")) {
    const lineBeforeCajero = document.createElement('div');
    lineBeforeCajero.className = 'line';
    p.insertAdjacentElement('beforebegin', lineBeforeCajero);
  }
});

  // Añadir la línea al final del comprobante
  const footerLine = document.createElement('div');
  footerLine.className = 'footer-line';
  ventanaImpresion.document.body.appendChild(footerLine);

  ventanaImpresion.document.write('</body></html>');

  // Forzar que la ventana se imprima
  ventanaImpresion.document.close();
  
  // Cerrar la ventana modal después de la impresión
  ventanaImpresion.print();
  
  // Restaurar la visibilidad de los botones después de la impresión
  botones.forEach(button => button.style.display = 'inline-block'); // Restaurar los botones
  
  // Cerrar el modal de impresión
  handleCloseModalImpresora();  // Cierra el modal
};

useEffect(() => {
  if (verPendientes) {
    fetchPagosPendientes();
  } else {
    fetchPagos();
  }
}, [verPendientes]);

useEffect(() => {
  filterPagos(searchTerm);
}, [searchTerm, verPendientes]);


const fetchPagosPendientes = async () => {
  try {
    const response = await axios.get(`${API_URL_PAGOS}/pendientes`);
    
    setPagos(response.data);
    setFilteredPagos(response.data);
    
    console.log('Pagos pendientes mostrados:', response.data); // 👈 Aquí ves lo que se está mostrando

  } catch (error) {
    console.error('Error al obtener pagos pendientes:', error);
  }
};



  return (
    <div className="pagos-panel">
      <div className="header-buttons">
        <Button className="btnPagar" variant="primary" onClick={handleOpenModal}>
          + PAGAR
        </Button>
        <Button variant={verPendientes ? "secondary" : "success"} onClick={() => setVerPendientes(!verPendientes)}
        >
          {verPendientes ? "Ver Todos los Pagos" : "Consultar Pagos Pendientes"}
        </Button>

      </div>
      <h2>Gestión de Pagos</h2>

      <div className="search-bar">
        <Form.Control
          type="text"
          placeholder="Buscar por Código de Medidor"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="pagos-panel1">
        <table className="pagos-table">
          <thead>
            <tr>
              <th>Código de Medidor</th>
              <th>Lectura Anterior</th>
              <th>Lectura Actual</th>
              <th>Mes</th>
              <th>Consumo m3</th>
              <th>Exceso m3</th>
              <th>Mora</th>
              <th>Reconexión</th>
              <th>Fecha de Pago</th>
              <th>Sub Total</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
          {(verPendientes ? filteredPagos.filter(p => p.estado !== 'PAGADO') : filteredPagos).map((pago, index) => (
            <tr key={index}>
              <td>{pago.codigo_medidor}</td>
              <td>{pago.lectura_anterior}</td>
              <td>{pago.lectura_actual}</td>
              <td>{pago.mes}</td>
              <td>{pago.consumo}</td>
              <td>{pago.exceso}</td>
              <td>{pago.mora}</td>
              <td>{pago.reconexion}</td>
              <td>{moment.utc(pago.fecha_pago).format('DD/MM/YYYY')}</td>
              <td>{pago.total_pagar}</td>
              <td>{pago.estado}</td>
              <td>
                <button
                  className={`arrow-button ${selectedRows[index] ? "selected" : ""}`}
                  onClick={() => toggleSelection(index)}
                >
                  <FontAwesomeIcon
                    icon={
                      selectedRows[index]
                        ? faArrowRotateRight
                        : faArrowRight
                    }
                  />
                </button>
                {pago.estado === "PAGADO" && (
                  <button
                    className="print-button"
                    onClick={() => handleImpresoraClick(pago)}
                  >
                    <FontAwesomeIcon
                      icon={faPrint}
                      size="2x"
                      color="#7c3317"
                    />
                  </button>
                )}
              </td>
            </tr>
          ))}

          </tbody>
        </table>
      </div>

      {/* Modal para agregar/editar pagos */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Registros Seleccionados para Pagar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <thead>
              <tr>
                <th>Código de Medidor</th>
                <th>Lectura Anterior</th>
                <th>Lectura Actual</th>
                <th>Mes</th>
                <th>Consumo</th>
                <th>Exceso</th>
                <th>Mora</th>
                <th>Reconexión</th>
                <th>Fecha de Pago</th>
                <th>Sub Total</th>
              </tr>
            </thead>
            <tbody>
              {Object.values(selectedRows).map((pago, idx) => (
                <tr key={idx}>
                  <td>{pago.codigo_medidor}</td>
                  <td>{pago.lectura_anterior}</td>
                  <td>{pago.lectura_actual}</td>
                  <td>{pago.mes}</td>
                  <td>{pago.consumo}</td>
                  <td>{pago.exceso}</td>
                  <td>{pago.mora}</td>
                  <td>{pago.reconexion}</td>
                  <td>{new Date(pago.fecha_pago).toLocaleDateString()}</td>
                  <td>{pago.total_pagar}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="7" style={{ textAlign: 'right' }}><strong>TOTAL A PAGAR:</strong></td>
                <td><strong>{totalPagar}</strong></td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
            <Button 
              variant="primary" 
              onClick={handleAddPago} 
              disabled={isProcessing} // Deshabilitar el botón si el proceso está en curso
            >
              {isProcessing ? 'Procesando...' : 'Confirmar Pago'}
            </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para imprimir comprobante */}
      <Modal
  className="custom-modal"
  show={showModalImpresora}
  onHide={handleCloseModalImpresora}
>
  <Modal.Header closeButton>
    <Modal.Body>

      {selectedPago ? (
        <div>
          <div className="intro-image">
            <img src={logo} alt="Logo" className="logo-centered" />
          </div>

          <p className="big-text"><strong></strong> {selectedPago.nombre_aplicacion}</p>
          <p><strong>COMPROBANTE DE PAGO No:</strong> {selectedPago.numero_comprobante}</p>
          <p><strong>Cajero:</strong> {selectedPago.nombre_usuario}</p>
            <img
              src={selectedPago.imagen_sello}
              alt="Sello de comprobante"
              style={{ maxWidth: "320px", maxHeight: "100px", marginTop: "10px" }}
            />
        </div>
      ) : (
        <p>No se ha seleccionado ningún pago.</p>
      )}
    </Modal.Body>
  </Modal.Header>
  <Modal.Body>
    {selectedPago ? (
      <div>
        <p><strong>Código de Medidor:</strong> {selectedPago.codigo_medidor}</p>
        <p><strong>Cedula Cliente:</strong> {selectedPago.codigo_cliente}</p>
        <p><strong>Nombre Cliente:</strong> {selectedPago.nombre_cliente}</p>
        <p><strong>Lectura Anterior:</strong> {selectedPago.lectura_anterior}</p>
        <p><strong>Lectura Actual:</strong> {selectedPago.lectura_actual}</p>
        <p><strong>Mes:</strong> {selectedPago.mes}</p>
        <p><strong>Consumo m³:</strong> {selectedPago.consumo}</p>
        <p><strong>Exceso m³:</strong> {selectedPago.exceso}</p>
        <p><strong>Mora:</strong> {selectedPago.mora}</p>
        <p><strong>Reconexión:</strong> {selectedPago.reconexion}</p>
        <p><strong>Fecha de Pago:</strong> {moment(selectedPago.fecha_pago).tz('America/Guayaquil').format('DD/MM/YYYY')}</p>
        <p><strong>Total Pagar:</strong> {selectedPago.total_pagar}</p>
      </div>
      
    ) : (
      <p>No se ha seleccionado ningún pago.</p>
      
    )}
    <br />
    <p style={{ textAlign: 'left', maxWidth: '250px', wordWrap: 'break-word' }}>
      Para revisar los consumos pendientes de tu cuenta, visita:  
      <br /> www.juntadeaguasantacruz.com
    </p>

  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseModalImpresora}>
      Cancelar
    </Button>
    <Button
      variant="primary"
      onClick={() => {
        generarComprobante(selectedPago); // Aquí llamamos a la función de generación de comprobantes
        handleCloseModalImpresora(); // Cerramos el modal después de imprimir
      }}
    >
      Imprimir
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default Pagos;
